//src/admin/pages/AdminEmailTemplateManager.js
import React, { useEffect, useState } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { adminApiRequest } from "../../services/adminApi";

function AdminEmailTemplateManager() {
  const [isOpen, setIsOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

const [showConfirm, setShowConfirm] = useState(false);

const [showEmailPicker, setShowEmailPicker] = useState(false);
const [emails, setEmails] = useState([]);
const [selected, setSelected] = useState([]);

const [sending, setSending] = useState(false);
const [showSendSuccess, setShowSendSuccess] = useState(false);

const [activeCampaign, setActiveCampaign] = useState(null);



  useEffect(() => {
   adminApiRequest("/admin/email-templates")
  .then((data) =>
    setTemplates(
  data.filter((t) =>
    ["discount_campaign", "new_collection"].includes(t.template_key)
  )
)
  )
  .finally(() => setLoading(false));
  }, []);

  const updateTemplate = (id, field, value) => {
    setTemplates((prev) =>
      prev.map((t) =>
        t.id === id ? { ...t, [field]: value } : t
      )
    );
  };

  const saveTemplate = async (tpl) => {
  await adminApiRequest(`/admin/email-templates/${tpl.id}`, {
    method: "PUT",
    body: JSON.stringify(tpl),
  });

  setShowConfirm(true);

  // auto-close after 2 seconds (optional but polished)
  setTimeout(() => setShowConfirm(false), 2000);
};

const sendDiscountCampaign = async () => {
  await adminApiRequest("/admin/email-templates/discount-campaign/send", {
    method: "POST",
  });

  setShowConfirm(true);
  setTimeout(() => setShowConfirm(false), 2000);
};

const sendNewCollectionCampaign = async () => {
  await adminApiRequest("/admin/email-templates/new-collection/send", {
    method: "POST",
  });

  setShowConfirm(true);
  setTimeout(() => setShowConfirm(false), 2000);
};


  return (
    <div className="flex bg-gray-100 min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex-1 lg:ml-64">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-6 space-y-6">
          <h1 className="text-2xl font-bold">Email Templates</h1>

          {loading ? (
            <p>Loading...</p>
          ) : (
            templates.map((t) => (
              <div key={t.id} className="bg-white p-5 rounded-xl shadow">
                <h2 className="font-bold mb-3">{t.template_key}</h2>

                {/* 🔹 DISCOUNT CAMPAIGN */}
{t.template_key === "discount_campaign" && (
  <input
    className="w-full border p-2 mb-2"
    type="number"
    min="1"
    max="90"
    value={t.subject_en}
    onChange={(e) =>
      updateTemplate(t.id, "subject_en", e.target.value)
    }
    placeholder="Discount percent (e.g. 20)"
  />
)}

{/* 🔹 NEW COLLECTION */}
{t.template_key === "new_collection" && (
  <>
    <input
      className="w-full border p-2 mb-2"
      value={t.subject_en}
      onChange={(e) =>
        updateTemplate(t.id, "subject_en", e.target.value)
      }
      placeholder="Collection name (EN)"
    />

    <input
      className="w-full border p-2 mb-2"
      value={t.subject_ar}
      onChange={(e) =>
        updateTemplate(t.id, "subject_ar", e.target.value)
      }
      placeholder="اسم التشكيلة (AR)"
    />
  </>
)}


               <div className="flex gap-3 mt-3">
  <button
    onClick={() => saveTemplate(t)}
    className="px-4 py-2 bg-black text-white rounded"
  >
    Save
  </button>

  {t.template_key === "discount_campaign" && (
    <button
      onClick={async () => {
  const data = await adminApiRequest(
    "/admin/email-templates/discount-campaign/emails"
  );
  setEmails(data);
  setSelected([]);
  setActiveCampaign("discount"); // ✅ ADD
  setShowEmailPicker(true);
}}
      className="px-4 py-2 bg-cyan-600 text-white rounded"
    >
      Send Discount Email
    </button>
  )}

  {t.template_key === "new_collection" && (
    <button
      onClick={async () => {
  const data = await adminApiRequest(
    "/admin/email-templates/discount-campaign/emails"
  );
  setEmails(data);
  setSelected([]);
  setActiveCampaign("new_collection"); // ✅ ADD
  setShowEmailPicker(true);
}}
      className="px-4 py-2 bg-purple-600 text-white rounded"
    >
      Send New Collection Email
    </button>
  )}
</div>
</div>
            ))
          )}

          {showConfirm && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl shadow-xl p-6 w-80 animate-fadeSlide text-center">
      <div className="text-green-600 text-4xl mb-3">✓</div>

      <h2 className="text-lg font-bold text-gray-800 mb-1">
        Template Saved
      </h2>

      <p className="text-sm text-gray-600 mb-4">
        Email template was updated successfully.
      </p>

      <button
        onClick={() => setShowConfirm(false)}
        className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition"
      >
        OK
      </button>
    </div>
  </div>
)}

{showSendSuccess && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl shadow-xl p-6 w-80 animate-fadeSlide text-center">
      <div className="text-green-600 text-4xl mb-3">✓</div>

      <h2 className="text-lg font-bold text-gray-800 mb-1">
        Emails Sent
      </h2>

      <p className="text-sm text-gray-600 mb-4">
        Campaign emails were sent successfully.
      </p>

      <button
        onClick={() => setShowSendSuccess(false)}
        className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition"
      >
        OK
      </button>
    </div>
  </div>
)}


{showEmailPicker && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
    <div className="bg-white w-[420px] max-h-[80vh] rounded-xl p-5 flex flex-col">
      <h2 className="font-bold text-lg mb-3">Select recipients</h2>

      <div className="space-y-2 overflow-y-auto pr-1" style={{ maxHeight: "50vh" }}>
        {emails.map((email) => (
          <label key={email} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={selected.includes(email)}
              onChange={() =>
                setSelected((prev) =>
                  prev.includes(email)
                    ? prev.filter(e => e !== email)
                    : [...prev, email]
                )
              }
            />
            {email}
          </label>
        ))}
      </div>

      <div className="flex gap-3 mt-4">
        <button
          onClick={() => setShowEmailPicker(false)}
          className="px-4 py-2 bg-gray-200 rounded"
        >
          Cancel
        </button>

       <button
  disabled={sending || selected.length === 0}
  onClick={async () => {
    try {
      setSending(true);

      const endpoint =
        activeCampaign === "new_collection"
          ? "/admin/email-templates/new-collection/send"
          : "/admin/email-templates/discount-campaign/send-selected";

      await adminApiRequest(endpoint, {
        method: "POST",
        body: JSON.stringify({ emails: selected }),
      });

      setShowEmailPicker(false);
      setShowSendSuccess(true);
      setTimeout(() => setShowSendSuccess(false), 2000);
    } finally {
      setSending(false);
    }
  }}
  className={`px-4 py-2 rounded text-white transition ${
    sending || selected.length === 0
      ? "bg-gray-400 cursor-not-allowed"
      : activeCampaign === "new_collection"
      ? "bg-purple-600 hover:bg-purple-700"
      : "bg-cyan-600 hover:bg-cyan-700"
  }`}
>
  {sending ? "Sending..." : `Send (${selected.length})`}
</button>


      </div>
    </div>
  </div>
)}


        </main>
      </div>
    </div>
  );
}

export default AdminEmailTemplateManager;
